const LISTINGS_BULK_URL = `${LP_API_HOST}/listings/bulk`;

class LPClient {
  static fetchListings(ids) {
    return this.get(LISTINGS_BULK_URL, { ids });
  }

  static get(url, data) {
    return new Promise((resolve, reject) => {
      $.ajax({ url, data, type: 'GET' }).then((response) => {
        resolve(response);
      }).fail(err => reject(err));
    });
  }
}

export default LPClient;



// WEBPACK FOOTER //
// ./javascripts/components/lp_client.js